document.addEventListener("DOMContentLoaded", function () {
    let isLoading = false;

    var infiniteScroll = new Ajaxinate({
        container: '.js-grid',
        pagination: '#CollectionPagination',
        method: 'click',
        loadingText: 'Loading...',
        callback: function () {
            isLoading = false;

            var loader = document.querySelector('#CollectionPagination .loading-overlay__spinner');
            if (loader) loader.style.display = "none";

        document.querySelectorAll('.ProductItem').forEach(function (item) {
        if (getComputedStyle(item).visibility === "hidden") {
            item.style.visibility = "visible";
        }
    });
        }
    });

    // Button click handler
    document.addEventListener("click", function (e) {

        const btn = e.target.closest("#load-more-btn");
        if (!btn) return;

        e.preventDefault();

        if (isLoading) return;

        const nextLink = document.querySelector("#CollectionPagination a.pagination__next");

        if (!nextLink) {
            console.log("No next page found");
            return;
        }

        isLoading = true;

        // loader show
        const loader = document.querySelector('#CollectionPagination .loading-overlay__spinner');
        if (loader) loader.style.display = "inline-block";

        // IMPORTANT: trigger Ajaxinate properly
        nextLink.click();
    });
});
